import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

export const confirmDelete = async (name, itemName = "Delete this item") => {
  const result = await MySwal.fire({
    backdrop: true,
    heightAuto: false,

    customClass: {
      title: "swal-title-small",
      confirmButton: "swal-btn-small",
      cancelButton: "swal-btn-small",
      popup: "swal-popup-small",
      container: "swal-container-high-z",
    },

    title: "Confirm Delete",
    text: `Are you sure you want to delete ${name || itemName}?`,
    showCancelButton: true,
    confirmButtonText: "Yes, Delete",
    cancelButtonText: "Cancel",
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
  });

  return result.isConfirmed;
};

export const confirmLogout = async () => {
  const result = await MySwal.fire({
    backdrop: true,
    heightAuto: false,

    customClass: {
      title: "swal-title-small",
      confirmButton: "swal-btn-small",
      cancelButton: "swal-btn-small",
      popup: "swal-popup-small",
      container: "swal-container-high-z",
    },

    title: "Are you sure you want to logout?",
    showCancelButton: true,
    confirmButtonText: "Logout",
    cancelButtonText: "Cancel",
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
  });

  return result.isConfirmed;
};

export const confirmClearAll = async () => {
  const result = await MySwal.fire({
    backdrop: true,
    heightAuto: false,

    customClass: {
      title: "swal-title-small",
      confirmButton: "swal-btn-small",
      cancelButton: "swal-btn-small",
      popup: "swal-popup-small",
      container: "swal-container-high-z",
    },

    title: "Are you sure you want to clear all fields?",

    showCancelButton: true,
    confirmButtonText: "Clear All",
    cancelButtonText: "Cancel",
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
  });

  return result.isConfirmed;
};
